import React, { useEffect, useState, useRef } from 'react';
import withStyles from 'react-jss';
import { connect } from 'react-redux';
import { getTenantState } from '../../store/selectors';
import Chevron from '../user-dashboard/utility/Chevron';

const hoverOverFilterOptionStyles = {
  color: (props) => ({
    '&:hover': {
      backgroundColor: '#ededed',
      color: props.color,
      cursor: 'pointer',
    },
  }),
};

function MultipleChoiceMenu(props) {
  const choices = props.choices;
  const startingSelectedChoice = props.startingSelectedChoices;

  const [selectedChoices, setSelectedChoices] = useState(
    startingSelectedChoice
  );
  const [showDropdown, setShowDropdown] = useState(false);
  const [chevronTransform, setChevronTransform] = useState('rotate(90deg)');

  const divFilter = useRef();

  const toggleShowDropdown = (toShow = false) => {
    if (toShow) {
      setShowDropdown(true);
      setChevronTransform('rotate(270deg)');
    } else {
      setShowDropdown(false);
      setChevronTransform('rotate(90deg)');
    }
  };

  const handleClickOutside = (event) => {
    if (!(divFilter && divFilter.current)) return;

    if (!divFilter.current.contains(event.target)) {
      toggleShowDropdown(false);
    }
  };

  const handleCheck = (choice) => {
    if (props.multipleChoice) {
      if (selectedChoices.includes('View All')) {
        setSelectedChoices([choice]);
      } else if (choice === 'View All') {
        setSelectedChoices(['View All']);
      } else if (!selectedChoices.includes(choice)) {
        setSelectedChoices([...selectedChoices, choice]);
      } else if (selectedChoices.length === 1) {
        setSelectedChoices(['View All']);
      } else {
        setSelectedChoices(
          selectedChoices.filter((selectedChoice) => {
            return selectedChoice !== choice;
          })
        );
      }
    } else {
      setSelectedChoices([choice]);
      toggleShowDropdown(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      window.removeEventListener('mousedown', handleClickOutside);
    };
  });

  // Send the selected choice back to the parent component
  useEffect(() => {
    props.setSelectedChoices(selectedChoices);
  }, [selectedChoices]);

  return (
    <div className="multiple-choice-menu" ref={divFilter}>
      <div className="multiple-choice-menu__header">{`${props.headerText}:`}</div>
      <div
        className="multiple-choice-menu__button"
        onClick={() => toggleShowDropdown(!showDropdown)}
        onKeyDown={(e) => {
          if (['Enter'].includes(e.key)) toggleShowDropdown(!showDropdown);
        }}
        role="button"
        tabIndex={0}
        aria-label={`Click to ${
          showDropdown ? 'close' : 'open'
        } the menu. Currently selected: ${selectedChoices.join(', ')}`}
      >
        <div className="multiple-choice-menu__subheader">
          {selectedChoices.join(', ')}
        </div>
        <div className="multiple-choice-menu__subheader-chevron">
          <Chevron transform={chevronTransform} />
        </div>
      </div>

      {showDropdown && (
        <div className="multiple-choice-menu__dropdown">
          {choices.map((choice) => {
            return (
              <div
                className={[
                  'multiple-choice-menu__option',
                  props.classes.color,
                ].join(' ')}
                key={choice}
                onClick={() => handleCheck(choice)}
                onKeyDown={(e) => {
                  if (['Enter'].includes(e.key)) handleCheck(choice);
                }}
                role="menuitem"
                tabIndex={0}
              >
                <div className="multiple-choice-menu__checkbox-container">
                  {props.multipleChoice && (
                    <input
                      type="checkbox"
                      value
                      tabIndex={0}
                      checked={selectedChoices.includes(choice)}
                      onChange={() => handleCheck(choice)}
                      className="custom-checkbox"
                      style={
                        ({ border: '1px solid #555555' },
                        { color: props.color })
                      }
                      aria-label={`Check to select ${choice}.`}
                    />
                  )}
                  <label className="multiple-choice-menu__option-label">
                    {choice}
                  </label>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

const mapStateToProps = (state) => ({
  tenant: getTenantState(state),
});

export default withStyles(hoverOverFilterOptionStyles)(
  connect(mapStateToProps, {})(MultipleChoiceMenu)
);
